import { render, staticRenderFns } from "./StoryboardTabBrandsSelector.vue?vue&type=template&id=f84c4a34&scoped=true&"
import script from "./StoryboardTabBrandsSelector.vue?vue&type=script&lang=js&"
export * from "./StoryboardTabBrandsSelector.vue?vue&type=script&lang=js&"
import style0 from "./StoryboardTabBrandsSelector.vue?vue&type=style&index=0&id=f84c4a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84c4a34",
  null
  
)

export default component.exports